import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

import { isAzureAdEnabled } from './azure-ad-env';
import { AuthService } from './auth.service';
import { MsalTokenService } from './msal-token.service';

export const authGuard: CanMatchFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (isAzureAdEnabled()) {
    inject(MsalTokenService).tryEnsureMsalActiveAccount();
    const msal = inject(MsalService);
    if (msal.instance.getActiveAccount()) {
      return true;
    }
  }
  if (auth.isAuthenticated()) return true;
  return router.parseUrl('/login');
};

